import React from "react";
import { useState, useEffect } from "react";
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useDispatch, useSelector } from "react-redux";
import { HttpJsonHeader } from "../../../features/Environments";
import { Button, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { AiFillEdit, AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import {
  Bs7Circle,
  BsAmd,
  BsArrowThroughHeart,
  BsDiscord,
  BsGear,
} from "react-icons/bs";
import styled from "styled-components";

import { SerachBox } from "../../components/SerachBox";
import { PageOptions } from "../../components/PageParams";
import GoodsPopup from "./GoodsPopup";
import GoodsUnit from "../goods-component/GoodsUnit";
import ConfirmDialog, { GetConfirmTitle } from "../../components/ConfirmDialog";
import GoodsModality from "../goods-component/GoodsModality";
import GoodsCategory from "../goods-component/GoodsCategory";
import Specialty from "../goods-component/Specialty";
import SpecialtySub from "../goods-component/SpecialtySub";
import { setReminder } from "../../../features/UserActions";
import { BiCategory } from "react-icons/bi";
import { GetCreateTable } from "../../../core/Helper2";

export default function Goods() {
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.user.detail);
  const [data, setData] = useState([]);
  const [fields, setFields] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [showGoodUnit, setShowGoodUnit] = useState(false);
  const [showModality, setShowModality] = useState(false);
  const [showCategory, setShowCategory] = useState(false);
  const [showSpecialty, setShowSpecialty] = useState(false);
  const [showSubSpc, setShowSubSpc] = useState(false); // SubSpecialty
  const [updateFlag, setUpdateFlag] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);

  const props = {
    ...{ showConfirm, setShowConfirm, confirmAction, setConfirmAction },
    formName: "สินค้า-บริการ",
    show: popupVisible,
    fields: fields,
    hidePopup: () => {
      setPopupVisible(false);
    },
    setUpdate: setUpdateFlag,
    user: userDetail,
  };

  const propsGoodUnit = {
    ...props,
    ...{ showGoodUnit, setShowGoodUnit },
  };

  const propsModality = {
    ...props,
    ...{ showModality, setShowModality },
  };

  const propCategory = {
    ...props,
    ...{ showCategory, setShowCategory },
  };

  const propSpecialty = {
    ...props,
    ...{ showSpecialty, setShowSpecialty },
  };

  const propSubSpc = {
    ...props,
    ...{ showOption: [showSubSpc, setShowSubSpc] },
  };

  useEffect(() => {
    if (updateFlag) {
      getData("");
      setUpdateFlag(false);
    }
  }, [updateFlag]);

  const getData = (e) => {
    let criteria = null;
    if (e) {
      criteria = { criteria: e };
    }
    axios
      .post(
        process.env.REACT_APP_API + "api/goods/select",
        criteria,
        HttpJsonHeader
      )
      .then((response) => {
        setData(response.data.lists);
      })
      .catch((err) => alert(err));
  };

  const popupNew = () => {
    setFields(null);
    setPopupVisible(true);
  };

  const popupData = (row) => {
    setFields(row);
    setPopupVisible(true);
  };

  // **** DELETE ****
  const popupDelete = async (row) => {
    setShowConfirm(true);
    setConfirmAction({
      title: GetConfirmTitle("DELETE"),
      data: row,
      action: (row) => {
        axios
          .post(
            process.env.REACT_APP_API + "api/goods/delete",
            { GoodId: row.GoodId, UpdateBy: userDetail.userid },
            HttpJsonHeader
          )
          .then((res) => {
            dispatch(
              setReminder({
                show: true,
                message: "ยกเลิกสมบูรณ์",
                type: "success",
              })
            );
            setUpdateFlag(true);
          })
          .catch((err) => {
            dispatch(
              setReminder({ show: true, message: err.message, type: "error" })
            );
          });
      },
    });
  };

  const formatEditBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>แก้ไข</Tooltip>}
        >
          <Button
            variant="info"
            className="info-button"
            onClick={() => popupData(row)}
          >
            <AiFillEdit />
          </Button>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ลบ</Tooltip>}
        >
          <Button
            variant="danger"
            className="info-button"
            onClick={() => {
              popupDelete(row);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  const commonNonBorder = () => {
    return { border: "none", color: "var(--table-text-color)" };
  };
  const columns = [
    {
      dataField: "GoodCode",
      text: "รหัส",
      sort: true,
      style: commonNonBorder,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "GoodName",
      text: "ชื่อรายการ",
      sort: true,
      style: commonNonBorder,
    },
    {
      dataField: "GoodShort",
      text: "ชื่อสั้น",
      sort: true,
      style: commonNonBorder,
    },
    {
      dataField: "GoodUnitName",
      text: "หน่วยนับ",
      sort: true,
      style: commonNonBorder,
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: null,
      text: "",
      headerStyle: () => {
        return { width: "105px" };
      },
      formatter: formatEditBox,
      align: "center",
    },
  ];

  return (
    <div>
      <HBox style={{ margin: "5px" }}>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>เพิ่มข้อมูลใหม่</Tooltip>}
        >
          <Button variant="primary" onClick={popupNew}>
            <AiOutlinePlus /> เพิ่มข้อมูลใหม่
            {/* <Badge bg='warning'>9</Badge> */}
          </Button>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>หน่วยนับ</Tooltip>}
        >
          <ButtonStuff variant="warning" onClick={() => setShowGoodUnit(true)}>
            <BsGear />
          </ButtonStuff>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ประเภทสินค้า</Tooltip>}
        >
          <ButtonStuff variant="warning" onClick={() => setShowCategory(true)}>
            <BsGear />
          </ButtonStuff>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>Modality</Tooltip>}
        >
          <ButtonStuff variant="warning" onClick={() => setShowModality(true)}>
            <BsDiscord />
          </ButtonStuff>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>Specialty</Tooltip>}
        >
          <ButtonStuff variant="warning" onClick={() => setShowSpecialty(true)}>
            <AiFillEdit />
          </ButtonStuff>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>Sub Specialty</Tooltip>}
        >
          <ButtonStuff variant="warning" onClick={() => setShowSubSpc(true)}>
            <AiFillEdit />
          </ButtonStuff>
        </OverlayTrigger>

        <div className="table-caption-box-right-flex">{props.formName}</div>

        <SerachBox
          onButtonClick={(e) => {
            getData(e.current.value);
          }}
        />
      </HBox>

      {GetCreateTable({
        idFieldName: "GoodId",
        columns: columns,
        data: data,
      })}

      {/* <BoostrapTable
        bootstrap4
        keyField="GoodId"
        rowClasses={"table-next-rows-style"}
        headerWrapperClasses="headerWrapper"
        wrapperClasses="bs-table-wrapper"
        data={data}
        columns={columns}
        striped
        hover
        condensed
        bordered={true}
        pagination={paginationFactory(PageOptions)}
      /> */}

      <GoodsPopup props={props} />
      <ConfirmDialog {...props} />
      <GoodsUnit {...propsGoodUnit} />
      <GoodsModality {...propsModality} />
      <GoodsCategory {...propCategory} />
      <Specialty {...propSpecialty} />
      <SpecialtySub {...propSubSpc} />
    </div>
  );
}

const ButtonStuff = styled(Button)`
  margin-left: 2px;
  border-radius: 30%;
  background-color: #e65b0bc5;
  border: none;
  color: white;
`;

const HBox = styled.div`
  padding: 0px;
  display: flex;
`;
